var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMute") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons-states",
    transform: "translate(-70.000000, -340.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(57.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mute",
    transform: "translate(13.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icMute"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2041985,0.0773255647 C16.9336832,-0.0556631895 16.6331107,-0.0113336048 16.4076813,0.165984734 L9.75,5.3820992 L17.625,13.125 L17.625,0.742269335 C17.625,0.461515299 17.4596851,0.195537791 17.2041985,0.0773255647 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93855138,7.00026785 L5.49903568,7.00026785 C5.03401907,7.00026785 4.62900461,7.2102641 4.35899496,7.54025821 C4.13398693,7.79525366 3.99898211,8.1402475 3.99898211,8.50024107 L3.99898211,14.5001339 C3.99898211,15.3251192 4.67400621,16.0001071 5.49903568,16.0001071 L8.97915997,16.0001071 L16.2844209,21.8350029 C16.4194257,21.9400011 16.5844316,22 16.7494375,22 C16.8544412,22 16.9744455,21.9700005 17.0794493,21.9250013 C17.3344584,21.8050035 17.4994643,21.5350083 17.4994643,21.2500134 L17.4994643,18.5605614 L5.93855138,7.00026785 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    transform: "translate(12.020815, 12.020815) rotate(-45.000000) translate(-12.020815, -12.020815) ",
    x: 11.0208153,
    y: -3.97918472,
    width: 2,
    height: 32,
    rx: 1
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMute);
export default __webpack_public_path__ + "static/media/icMute.9c9687f15d1af47dd600dad0ed512d5b.svg";
export { ForwardRef as ReactComponent };